// services/api/birebirRaporService.ts
import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";
import { API_URL } from "../../constants/API_URL";
import { BirebirRaporError } from "../../types/ErrorModals/BirebirRaporError"; 
import { BirebirRaporRequestModal } from "../../types/RequestModals/BirebirRaporRequestModal";
import { BirebirRaporItem } from "../../types/modals";

export const getBirebirRapor = async (
  request: BirebirRaporRequestModal
): Promise<BirebirRaporItem[]> => {
  try {
    const response = await axios.post<ApiResponse<BirebirRaporItem[]>>(
      `${API_URL}/api/BirebirRapor/getBirebirRapor`,
      request
    );
    
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Birebir ders raporu bulunamadı",
          correlationId: responseData?.correlationId,
        } as BirebirRaporError;
      }
      
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as BirebirRaporError;
      }
      
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as BirebirRaporError;
    }
    
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as BirebirRaporError;
  }
};

export const exportBirebirRapor = async (
  request: BirebirRaporRequestModal
): Promise<Blob> => {
  try {
    const response = await axios.post(
      `${API_URL}/api/BirebirRapor/exportBirebirRapor`,
      request,
      {
        responseType: 'blob'
      }
    );
    
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      throw {
        message: "Excel dosyası oluşturulurken bir hata oluştu",
        correlationId: "export-error",
      } as BirebirRaporError;
    }
    
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as BirebirRaporError;
  }
};